import React, { memo, ReactNode } from 'react';

import DataGrid from '@plasma/ui.display.data-grid';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import LoadingComponent from '../../components/Loding-component/LoadingComponent';
import TopBarThemed from '../../components/top-bar-themed';
import themes from './themes';
import useUsersPageHook from './users-page.hook';
import * as styled from './users-page.styles';
import { TableContainer } from './users-page.styles';
import EditableTable from '../../components/edit-table';

export interface UsersPageProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

type Props = UsersPageProps & ThemeOverride;
type DataType = { firstName: string; lastName: string; age: number };

function UsersPage(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t, columnNames, displayDataForColumns, isLoading } = useUsersPageHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.UsersPage className={`users-page ${className ?? ''}`.trim()} style={style}>
        <TopBarThemed topHeading={t('manage-users')} />

        {isLoading ? (
          <LoadingComponent />
        ) : (
          <TableContainer>
            <DataGrid
              columns={columnNames}
              data={displayDataForColumns}
              disablePagination
              disableToolHeader
              disableGroupBy
              disableRowsSelection
              disableDragAndDrop
              hideColumns={['id', 'companyid', 'mop', 'tom', 'toc']}
            />
          </TableContainer>
        )}
        {children}
      </styled.UsersPage>
    </ThemeProvider>
  );
}

export default memo(UsersPage) as unknown as typeof UsersPage;
